<template>
  <div id="container" v-loading="loading">
    <!-- <div @click="isOK=false">竞拍失败</div>
    <div @click="isOK=true">竞拍成功</div> -->
    <h1 class="full_layout terms_title">{{ $t('base.bidHistory') }}</h1>
    <div class="full_layout bid_history_box" v-if="list">
      <!--  <span class="el-icon-warning text_red span_alert" v-if="CountDown(list.time)=='00:00'">You have to bid at least US $ 17.00</span> -->
      <span class="el-icon-success text_greed span_alert"
        v-if="CountDown(list.EffectiveTime) == '00:00' && isOK">{{ userInfo.NickName }}{{ $t('symbol.winner') }}</span>
      <!-- {{$t('symbol.outbidYou')}} -->
      <span class="el-icon-warning text_red span_alert"
        v-if="list.Status == 1 && !isOK && bidList.length > 0 && bidnum > 0">{{ $t('alert.increaseBid') }}</span>
      <span class="el-icon-success text_greed span_alert"
        v-if="list.Status == 1 && isOK">{{ $t('alert.highestBidEnd') }}</span>
      <div class="contact_box like_box" v-if="list">
        <el-image @click="goto()" class="like_img" :src="list.TitImg" fit="contain"></el-image>
        <div class="like_detail">
          <p @click="goto()">{{ list.Title }}</p>
        </div>
      </div>
      <div class="contact_box">
        <div class="bid_history_info info_list"><span
            class="text_gray">{{ list.Status == 1 ? $t('colon.CurrentBid') : $t('colon.winBid') }}</span>
          <div :class="{ 'text_greed': isOK, 'text_red': (!isOK && bidList.length > 0 && bidnum > 0) }">{{ areaSymbol }} <em
              v-if="list">{{ list.USD_Price }}</em></div>
        </div>
        <div class="bid_history_info info_list" v-if="domesticCustom">
          <span class="text_gray">{{ $t('colon.shippFee') }}</span>
          {{ domesticCustomText }}
        </div>
        <div class="bid_history_info info_list"><span class="text_gray">{{ $t('colon.itemNumber') }}</span>{{ list.Code }}
        </div>
        <div class="bid_history_info_box">
          <div class="bid_history_info"><span class="text_gray">{{ $t('colon.bid') }}&nbsp;</span>{{ list.AuctionCount }}
          </div>
          <div class="bid_history_info"><span
              class="text_gray">{{ $t('colon.bidders') }}&nbsp;</span>{{ list.AuctionsUserCount }}</div>
          <div class="bid_history_info"><span class="text_gray">{{ $t('colon.timeLeft') }}&nbsp;</span><span
              :class="getDown(list.EffectiveTime) == 1 ? 'text_red' : ''">{{ CountDown(list.EffectiveTime) }}</span></div>
          <div class="bid_history_info"><span
              class="text_gray">{{ $t('colon.duration') }}&nbsp;</span>{{ list.EffectiveDay }} {{ list.EffectiveDay != 1
    ? $t('base.days') : $t('base.day') }}</div>
          <div class="bid_history_info"><span
              class="text_gray">{{ $t('colon.timeEnd') }}&nbsp;</span>{{ list.EffectiveTime | setTime }}</div>
          <!-- {{progress.SRStatus ==2?'Completed':'Rescinded'}} -->
        </div>
        <el-button type="primary" @click="isAddCout()"
          v-if="list.Status == 1 && userInfo.MappingUserId != list.SellUserID">{{ $t('base.placeBid') }}</el-button>
      </div>
      <div class="bid_list_box">
        <div class="bid_list table_th_gray">
          <div>{{ $t('base.bidder') }}</div>
          <div>{{ $t('base.bidAmount') }}</div>
          <div>{{ $t('base.bidTime') }}</div>
        </div>
        <div class="bid_list" v-for="(item, index) in bidList" :key="index" v-if="bidList.length > 0"
          :class="[index > 0 ? 'text_gray' : '', item.IsAuto ? 'em' : '']">
          <div><span
              :class="[(CountDown(list.EffectiveTime) == '00:00' && isOK && index == 0 ? 'text_greed' : '')]">{{ item.CreateUserName }}
              ({{ item.BuyFavorableCount }})</span><span class="earth"
              :class="item.MemberSource"></span></div>
              <!-- v-if="item.MemberSource != userInfo.MemberSource" -->
          <div v-if="list"
            :class="[(CountDown(list.EffectiveTime) == '00:00' && index == 0 && bidnum > 0 && !isOK ? 'text_red' : ''), (isOK && index == 0 ? 'text_greed' : ''), (list.Status == 1 && !isOK && bidList.length > 0 && bidnum > 0 && index == 0 ? 'text_red' : '')]">
            {{ areaSymbol }} {{ item.USD_Price }}</div>
          <div>{{ item.CreateDate | setTime }}</div>
        </div>
      </div>
      <p class="text_gray" style="word-break: break-word;">{{ $t('alert.bidSituation') }}</p>
    </div>
    <place-bid ref="refPlaceBid" v-if="userInfo && list" :Visible="dislogType.placebid" @getDialog="getDialog"
      :Auction='isAuction' :time="list.EffectiveTime" :placeList="list"></place-bid>
    <get-change title="Add Phone Number" :domVisible='dislogType.changePhone' type="1" :userInfo="userInfo"
      @closeDialog="closeDialog" v-if='dislogType.changePhone' />
    <get-address v-if="dislogType.commodityaddress" :dialogVisible.sync="dislogType.commodityaddress"
      @closeDialog="closeDialog" :userInfo.sync="userInfo" />
  </div>
</template>
<script>
import * as signalR from '@aspnet/signalr'
import bus from '@/api/bus';
import { countDown, setUTC, getInfo, priceExchange, CensoredName, getTime, isUserDomest, isNumber } from "@/api/public";
import PlaceBid from "@/components/dialog/placebid";
import GetChange from "@/components/dialog/changePhone"; // 修改手机号或邮箱
import GetAddress from "@/components/dialog/commodityaddress"; // 收货地址
export default {
  name: 'tabslist',
  components: { PlaceBid, GetChange, GetAddress },
  data() {
    return {
      areaSymbol: this.$store.state.areaSymbol,
      domesticCustom: null,
      domesticCustomText: '',
      loading: false,
      cid: '',
      userInfo: null,
      isOK: false,
      nowData: new Date().getTime(),
      showTipS: 5,
      dislogType: this.$enumInfo.dislogType,
      dialogVisible: false,
      list: null,
      bidList: [],
      isAuction: false,
      isread: true,
      priceBid: '',
      bidnum: 0,
      signal: '',
      isZero: 0,//计数器，当商品竞拍时间结束但是商品状态没变时 更新详情接口
    }
  },
  filters: {
    setExchange(val) {
      return priceExchange(val, 'USD')
    },
    // setName(val) {
    //   return CensoredName(val)
    // },
    setTime(val) {
      val = val.toString().replace(/-/g, "/")
      return getTime(val, -8, '', 'cn')
    }
  },
  created() {
    bus.$emit('headerTitle', this.$t('base.myCardHobby'));
    this.cid = this.$route.params.id
    this.userInfo = getInfo()
    this.getDetail()
    this.cardTimer();
  },
  mounted() {
    this.newSignalR(); //链接SOCKET
  },
  destroyed() {
    if (this.signal) {
      this.signal.stop();
    }
  },
  methods: {
    // 关闭并打开其他弹框
    openCloseDialog(openVal, closeVal, openBol, closeBol) {

      this.dislogType[openVal] = openBol;
      this.dislogType[closeVal] = closeBol;
    },
    /**
     * 初始化并建立 SignalR 实时通信连接
     * @description 创建 SignalR Hub 连接,配置自动重连机制,连接成功后加入指定群组
     * @param {void}
     * @returns {void} 
     * @private
     * 
     * - 使用 cid 作为群组标识
     * - 配置重连间隔为 1s/5s/10s/20s
     * - 连接成功后调用 connect 方法加入群组
     * - 连接失败自动重试
     * - 注册 addChatMessage 消息处理器
     */
    newSignalR() {
      let that = this;
      let group = that.cid; //connectionToken;
      let url = process.env.VUE_APP_CMS_SOCKET + "/hubs?cId=" + group;
      //console.log('VUE_APP_CMS_SOCKET', url)
      //.withAutomaticReconnect([1000,5000,10000,20000])
      that.signal = new signalR.HubConnectionBuilder().withUrl(url, {}).configureLogging(signalR.LogLevel.Information).build() //打印日志

      that.signal.start().then(() => {
        that.signal.invoke("connect", group);
        console.log('连接成功');
      }).catch((data) => {
        console.log('连接失败', data);
        that.signal.stop()
        that.newSignalR()
      })
      that.signal.on('addChatMessage', that.receiveData);
    },
    /**
     * 处理实时竞拍数据的回调函数
     * @param {string} msg WebSocket接收到的消息字符串
     * @description 接收竞拍数据并更新商品价格、竞拍次数等信息。
     * 主要功能:
     * - 解析竞拍数据并验证商品ID
     * - 更新商品最新价格和竞拍次数
     * - 处理竞拍用户名称的隐私保护
     * - 更新竞拍历史记录列表
     * - 判断当前用户是否为最高出价者
     */
    receiveData(msg) {
      let that = this;
      let data = eval('(' + msg + ')');
      console.log(data,'receiveData')
      if (data && data.CommodityID == that.cid) {
        if (that.list.SellUserID == that.userInfo.MappingUserId) {
          that.getDetail();
        } else {
          // var oldPrice = isNumber(that.list.Price)
          // var oldAuctionCount = that.list.AuctionCount
          var newPrice = priceExchange(data.List[0].Price, 'USD')
          var listFirst = data.List[0]
          //console.log((data.PriceCount != oldAuctionCount) && (listFirst.Price != oldPrice),'receiveData')
          //console.log(data.List,'receiveData')
          //if ((data.PriceCount != oldAuctionCount) && (listFirst.Price != oldPrice)) {
          const setDetail = function () {
            if (data.List.length > 0) {
              that.list.Price = data.List[0].Price
              that.list.USD_Price = newPrice
              that.list.AuctionCount = data.PriceCount
              that.list.AuctionsUserCount = data.UserCount
              const CensoredRealName = function (val) {
                let name = val.RealName
                //console.log(val,'val1111')
                if (val.AuctionUserID == that.userInfo.MappingUserId) {
                  name = that.userInfo.NickName
                }else{
                  if (name.length > 1) {
                    let name1 = name.substr(0, 1)
                    let name2 = name.substr(name.length - 1, 1)
                    name = name1 + '***' + name2
                  }
                }
                return name
              }
              // let actionList = {
              //   BuyFavorableCount: listFirst.Favs,
              //   CommodityID: data.CommodityID,
              //   CreateDate: listFirst.ActionTime,
              //   CreateUser: listFirst.AuctionUserID,
              //   CreateUserName: CensoredRealName(listFirst.RealName),
              //   ID: 0,
              //   IsAuto: listFirst.IsAuto ? true : false,
              //   MemberSource: listFirst.MemberSource,
              //   Price: listFirst.Price,
              //   Status: 0,
              //   USD_Price: priceExchange(listFirst.Price, 'USD')
              // }
              let AuctionsList = []
              if (data.List.length > 0) {
                data.List.map(item => {
                  let actionList = {
                    BuyFavorableCount: item.Favs,
                    CommodityID: data.CommodityID,
                    CreateDate: item.ActionTime,
                    CreateUser: item.AuctionUserID,
                    CreateUserName: CensoredRealName(item),
                    ID: 0,
                    IsAuto: item.IsAuto ? true : false,
                    MemberSource: item.MemberSource,
                    Price: item.Price,
                    Status: 0,
                    USD_Price: priceExchange(item.Price, 'USD')
                  }
                  AuctionsList.push(actionList)
                })
              }
              //that.list.List
              //that.list.Auctions.push(actionList)
              //console.log(AuctionsList,'listFirst')
              that.list.Auctions = AuctionsList
              that.bidList = AuctionsList;
              //that.bidList = result.Auctions;
              //判断是否是最高出价或者已经胜利的
              //
              let num = 0;
              if (data.List[0].AuctionUserID == that.userInfo.MappingUserId) {
                that.isOK = true
              } else {

                //console.log('that.false')
                that.isOK = false
                data.List.map(r => {
                  if (r.AuctionUserID == that.userInfo.MappingUserId) {
                    num++;
                  }
                })
                that.bidnum = num
              }
            }
          }
          //測試只改list 不重新調商品詳情的接口
          setDetail()
          //that.getDetail();
          //}
          //that.getDetail();
          //that.cardTimer();
        }
      }
    },

    //竞拍资格校验
    /**
     * 检查用户竞拍资格
     * 通过接口验证用户是否具备竞拍条件
     * @returns {Promise} 返回竞拍校验结果
     * - 当 result=1 时,表示校验通过,可以参与竞拍
     * - 当 result!=1 时,返回保证金和总金额信息
     */
    getAuctionCheck() {
      let that = this
      let data = { 'operator_id': this.userInfo.MappingUserId, 'memberid': this.userInfo.MappingUserId, 'token': this.userInfo.ChineseToken, 'CommodityID': this.list.ID }
      this.$get(this.$interface.AuctionCheck, data).then(res => {
        that.isread = false;
        if (res.result == 1) {
          that.isAuction = true;
          that.dislogType.placebid = true;
        } else {
          that.list.DepositNum = res.data.DepositNum;
          that.list.SumMoney = res.data.SumMoney;
          that.isAuction = false;
          that.dislogType.placebid = true;
        }
        //this.getPrice()
        // msg: '竞拍校验通过', result: 1
      })
    },
    // 判断默认地址是否为空
    /**
     * 检查用户是否可以继续竞拍
     * 验证用户身份状态、电话号码和地址信息
     * 如果用户未通过身份验证,弹出身份验证对话框
     * 如果用户未设置电话,弹出修改电话对话框
     * 如果用户未设置地址,弹出设置地址对话框
     * 如果验证通过则调用 getAuctionCheck 方法
     */
    isAddCout() {
      let that = this
      that.userInfo = getInfo()
      if (that.userInfo.VerifyStatus == 2) {
        if (!that.userInfo.TelPhone) {
          that.dislogType['changePhone'] = true;
        } else {
          if (that.userInfo.Count > 0) {
            that.getAuctionCheck()
          } else {
            this.$confirm(that.$t('alert.noAddress'), that.$t('base.somethingImportant'), {
              confirmButtonText: that.$t('base.goToSet'),
              cancelButtonText: that.$t('base.cancel'),
              lockScroll: false
            }).then(() => {
              that.dislogType['commodityaddress'] = true;
            }).catch(() => { });
          }
        }
      } else {
        that.title = that.$t('kyc.IDVerification')
        that.dislogType['idverification'] = true;
      }
    },
    // 获取最新价格
    /**
     * 获取商品竞拍价格信息
     * @description 通过用户ID和商品ID获取竞拍价格数据
     * @method getPrice
     * @private
     * @returns {void} 将竞拍价格数据存储到 priceBid 变量中
     */
    getPrice() {
      let that = this
      let data = { 'operator_id': this.userInfo.MappingUserId, 'memberid': this.userInfo.MappingUserId, 'token': this.userInfo.ChineseToken, 'CommodityID': this.list.ID }
      this.$get(this.$interface.AuctionIndex, data).then(res => {
        if (res.result != 0) {
          that.priceBid = res.data
        }
      })
    },
    // 获取商品详情
    /**
     * 获取商品竞拍详情信息
     * 发送请求获取商品详情,包含竞拍历史记录、当前最高价等信息
     * 处理价格转换、竞拍状态判断、运费显示等逻辑
     * @method getDetail
     * @private
     * @returns {void}
     * 
     * 主要功能:
     * - 获取商品竞拍详情数据
     * - 处理价格单位转换
     * - 判断用户是否为最高出价者
     * - 计算用户竞拍次数
     * - 处理运费显示逻辑
     */
    getDetail() {
      this.loading = true
      let that = this;
      let data = { 'memberid': '', 'CommodityID': this.cid }
      //console.log(1111,that.userInfo.NickName)
      if (that.userInfo != null) {
        data = { 'memberid': that.userInfo.MappingUserId, 'token': that.userInfo.ChineseToken, 'operator_id': that.userInfo.MappingUserId, 'CommodityID': this.cid, buyerSource: that.userInfo.MemberSource }
      }
      that.$get(that.$interface.DetailCommodity, data).then(res => {
        if (res.result != 0) {
          let result = res.data
          let num = 0;
          result.HighestPrice = priceExchange(result.HighestPrice, 'USD')
          //if(that.userInfo.)
          that.list = result;

          //console.log(countDown(val, newval),'countDown(result.EffectiveTime, -8)')
          if (that.isZero == 1) {
            that.list.Status = -2
          }

          that.$nextTick(() => {
            that.$refs.refPlaceBid.list = result;
          });
          that.bidList = result.Auctions;
          var domesticCustom = isUserDomest(that.userInfo, result.DomesticCustom, result.MemberSource)
          //判断是否是最高出价或者已经胜利的
          if(that.bidList.length>0){
            if (result.Auctions[0].CreateUserName == that.userInfo.NickName) {
              that.isOK = true
            } else {
              that.isOK = false

              result.Auctions.map(r => {
                if (r.CreateUserName == that.userInfo.NickName) {
                  num++;
                }
              })
              that.bidnum = num
            }
          }
          that.domesticCustom = domesticCustom
          if (domesticCustom.Status == 1) {
            that.domesticCustomText = that.$t('base.freeShipping')
          } else if (domesticCustom.Status == 2) {
            that.domesticCustomText = result.MemberSource != 'US' ? that.$t('alert.PaidOnDelivery') : that.$t('base.payOnDelivery')
          } else if (domesticCustom.Status == 3) {
            that.domesticCustomText = that.areaSymbol + ' ' + domesticCustom.USD_Price
          }
          that.loading = false
        } else {
          that.loading = false
        }
      })
    },
    getDialog(val, val1) {
      this.dislogType.placebid = val
      this.isAuction = false
      this.getDetail()
    },
    // 关闭添加手机号弹框
    /**
     * 关闭对话框并处理相关状态更新
     * @param {string|number} val - 对话框类型标识
     * @param {boolean} bol - 对话框显示状态
     * @param {string|number} type - 操作类型，1表示更新用户信息，'commodity'表示更新用户信息和商品详情
     */
    closeDialog(val, bol, type) {
      this.dislogType[val] = bol;
      if (type == 1) {
        this.userInfo = getInfo()
      }
      if (type == 'commodity') {
        this.userInfo = getInfo()
        this.getDetail()
      }
    },
    /**
     * 计时器函数,每秒更新当前时间并处理提示倒计时
     * @description 设置一个1秒间隔的定时器,递增 nowData 值并递减 showTipS 计数
     * @private
     */
    cardTimer() {
      this.timer = setInterval(() => {
        this.nowData = this.nowData + 1000;
      }, 1000);
    },
    // 判断是否小于等于1分钟
    /**
     * 计算倒计时时间差
     * @param {string} itemEnd - 结束时间字符串，格式为 'YYYY/MM/DD HH:mm:ss'
     * @returns {string} 返回格式化后的倒计时字符串
     * @description 将输入的结束时间转换为标准格式，并根据当前时间计算倒计时
     * 时间差值。使用 UTC-8 时区进行时间转换，适配中国时区。
     */
    getDown(itemEnd) {
      itemEnd = itemEnd.toString().replace(/-/g, "/")
      //console.log(itemEnd)
      let val = setUTC(itemEnd, -8, 'cn')
      let newval = setUTC(this.nowData, -8)
      return countDown(val, newval, 0)
    },
    //
    CountDown(itemEnd) {
      itemEnd = itemEnd.toString().replace(/-/g, "/")
      //console.log(itemEnd)
      let val = setUTC(itemEnd, -8, 'cn')
      let newval = setUTC(this.nowData, -8)
      //console.log(val,newval)
      let time = countDown(val, newval)
      if (time == '00:00' && this.list.Status == 1 && this.isZero == 0) {
        this.isZero = 1
        this.getDetail()
      }
      return time
    },
    goto() {
      this.$router.push({ path: '/carddetails/' + this.list.ID })
    }
  }
}

</script>
<style scoped>
@import "../../../static/css/terms.css";
@import "../../../static/css/flag.css";

.earth {
  margin-left: 10px;
  padding: 0 24px 0 0;
  background: url(/static/images/icon/icon_earth.svg) no-repeat ;
}

.bid_history_box {
  margin-bottom: 24px;
}

.contact_box {
  /* width: 544px; */
  margin-bottom: 24px;
}

.like_box {
  display: flex;
}

.like_box .like_img {
  width: 88px;
  height: 88px;
  background-color: #e0e0e0;
  border-radius: 6px;
  margin-right: 12px;
  cursor: pointer;
}

.like_detail {
  width: 544px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* width: 80%; */
  font-size: 16px;
}

.like_detail p {
  cursor: pointer;
}

.like_detail p:hover {
  color: #5F6DAE;
}

.bid_list_box {
  border-top: 1px solid #e0e0e0;
  padding-top: 24px;
  margin-bottom: 16px;
}

.bid_list {
  display: flex;
  border-bottom: 1px solid #e0e0e0;
  height: 48px;
  align-items: center;
}

.bid_list>div {
  width: 33%;
  padding: 0 12px;
}

.bid_list.em>div {
  font-style: italic;
  /* color: #a0a0a0; */
}

.span_alert {
  padding: 16px;
  border: 1px solid #e0e0e0;
  background-color: #f7f7f7;
  border-radius: 4px;
  min-width: 300px;
  display: inline-block;
  margin-bottom: 20px;
}

.span_alert.el-icon-warning {
  border-color: #F9D2D2;
  background-color: #FDF4F4;
}

.bid_history_info {
  display: flex;
  margin-bottom: 24px;
  align-items: flex-end;
  font-size: 16px;
}

.bid_history_info>span {
  width: 20%;
}

.bid_history_info>div {
  display: flex;
  align-items: flex-end;
}

.bid_history_info>div>em {
  font-size: 24px;
  line-height: 0.9;
  font-weight: bold;
  margin-left: 2px;
}

.bid_history_info.info_list {
  width: 50%;
}

.bid_history_info_box {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.bid_history_info_box .bid_history_info>span {
  width: auto;
}

.el-button {
  padding: 11px 20px;
  line-height: 16px;
}

.el-icon-success {
  background: rgba(239, 247, 230, 1);
  border: 1px solid rgba(222, 238, 204, 1);
}
</style>



// WEBPACK FOOTER //
// src/pages/user/bidhistory.vue